import { DomainStoryblok, MultilinkStoryblok } from 'storyblok-types';
import { AppRoutes } from 'modules/shop/routes';
import { SHOP_LOCALES } from 'commerce/scayle/constants';
import { getSiteConfigStory } from './api';

export const getStoryblokUrl = (link?: MultilinkStoryblok): string => {
  if (!link) {
    return '';
  }

  return link.linktype === 'story' ? link.story?.url : link.url;
};

export const getCategoryHreflangAttributes = async ({
  locale,
  categoryPath,
  api,
}: {
  locale: string;
  categoryPath: string;
  api: {
    getSiteConfigStory: typeof getSiteConfigStory;
  };
}) => {
  const siteConfig = await api.getSiteConfigStory(locale);
  const domains: DomainStoryblok[] =
    siteConfig?.response?.data.story.content.domains;

  if (!domains?.length) {
    return;
  }

  const hreflangs = domains.reduce<Record<string, string>>((acc, domain) => {
    const categoryUrl =
      categoryPath === AppRoutes.HOME
        ? domain.url
        : `${domain.url}${categoryPath}`;

    if (!acc['x-default'] && domain.locale?.toUpperCase() === SHOP_LOCALES.DE) {
      /** x-default field should be on the first position  */
      acc = { 'x-default': categoryUrl, ...acc };
    }

    acc[domain.language] = categoryUrl;

    return acc;
  }, {});

  return hreflangs;
};
